import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiDocStyles } from '../styles/apiDocStyles';
import MethodBadge from './MethodBadge';

const DocSidebar = ({
  apiData,
  selectedCategory,
  selectedEndpoint,
  onSelectCategory,
  onSelectEndpoint,
  isMobile,
  isOpen,
  onClose
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [expandedCategories, setExpandedCategories] = useState(
    apiData.categories.reduce((acc, cat) => ({ ...acc, [cat.id]: true }), {})
  );

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const handleEndpointClick = (categoryId, endpointId) => {
    onSelectCategory(categoryId);
    onSelectEndpoint(endpointId);
    if (isMobile) onClose();
  };

  const sidebarStyle = {
    ...apiDocStyles.sidebar,
    ...(isMobile && {
      position: 'fixed',
      left: isOpen ? 0 : '-280px',
      zIndex: 1001,
      transition: 'left 0.3s ease',
      boxShadow: isOpen ? '4px 0 20px rgba(0,0,0,0.15)' : 'none',
    }),
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isMobile && isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 1000,
          }}
          onClick={onClose}
        />
      )}

      <aside style={sidebarStyle}>
        {/* Logo / Back to App */}
        <div style={apiDocStyles.sidebarHeader}>
          <div
            style={apiDocStyles.sidebarLogo}
            onClick={() => navigate('/main')}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>{t('apiDoc.backToApp')}</span>
          </div>
        </div>

        {/* API Doc Title */}
        <div style={{ padding: '0 20px 16px', borderBottom: '1px solid #e5e7eb', marginBottom: '8px' }}>
          <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
            {t('apiDoc.title')}
          </h2>
          <p style={{ fontSize: '13px', color: '#6b7280', margin: '4px 0 0' }}>
            v1.0
          </p>
        </div>

        {/* Category List */}
        <nav>
          {apiData.categories.map(category => (
            <div key={category.id}>
              {/* Category Header */}
              <div
                style={apiDocStyles.sidebarCategory}
                onClick={() => toggleCategory(category.id)}
              >
                <span>{category.name}</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  style={{
                    transform: expandedCategories[category.id] ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease',
                  }}
                >
                  <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>

              {/* Endpoints */}
              {expandedCategories[category.id] && (
                <div>
                  {category.endpoints.map(endpoint => {
                    const isActive = selectedCategory === category.id && selectedEndpoint === endpoint.id;
                    return (
                      <div
                        key={endpoint.id}
                        style={apiDocStyles.sidebarMenuItem(isActive)}
                        onClick={() => handleEndpointClick(category.id, endpoint.id)}
                        onMouseEnter={(e) => {
                          if (!isActive) {
                            e.currentTarget.style.backgroundColor = '#f3f4f6';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isActive) {
                            e.currentTarget.style.backgroundColor = 'transparent';
                          }
                        }}
                      >
                        <MethodBadge method={endpoint.method} />
                        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {endpoint.name}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default DocSidebar;
